import {
	Button,
	Divider,
	Drawer,
	FormControl,
	FormControlLabel,
	Radio,
	RadioGroup,
	Stack,
	Typography,
	useColorScheme,
} from '@mui/material'

type Props = {
	open: boolean
	onClose: () => void
}

export function UserSettingsDrawer({ open, onClose }: Props) {
	const { mode, setMode } = useColorScheme()

	if (!open) return null

	return (
		<Drawer open={open} anchor="right" onClose={onClose} data-testid="user-settings-drawer">
			<Stack spacing={3} sx={{ width: '25rem', p: 2 }}>
				<Stack
					direction="row"
					sx={{ width: '100%', mb: 2 }}
					alignItems="center"
					justifyContent="space-between"
				>
					<Typography variant="h6">Settings</Typography>
					<Button onClick={onClose} color="secondary">
						Close
					</Button>
				</Stack>

				<Divider />

				<FormControl>
					<Typography>Theme</Typography>
					<RadioGroup
						name="theme-toggle"
						row
						value={mode}
						onChange={(event) => setMode(event.target.value as 'light' | 'dark' | 'system')}
					>
						<FormControlLabel
							value="system"
							control={<Radio />}
							label="System"
							data-testid="system"
						/>
						<FormControlLabel value="light" control={<Radio />} label="Light" data-testid="light" />
						<FormControlLabel value="dark" control={<Radio />} label="Dark" data-testid="dark" />
					</RadioGroup>
				</FormControl>
			</Stack>
		</Drawer>
	)
}
